import React from 'react'

export default function IcClock(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M19 12a7 7 0 1 1-14 0 7 7 0 0 1 14 0Zm2 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-8-5a1 1 0 1 0-2 0v5a1 1 0 0 0 .293.707l2 2a1 1 0 0 0 1.414-1.414L13 11.586V7Z" fill="currentColor" />
    </svg>
  )
}
